<template>
    <div class="row justify-content-center">
        <div class="col-lg-8 col-xl-6">
            <StepsPercentage percentage="width:20%;" outerClass="mb-4" />

            <div class="card bg-white">
                <div class="card-body border-0">
                    <div class="chat-help d-flex align-items-center mb-4">
                        <div class="chat-help-avatar">
                            <img src="/images/chat-help-image.jpg" class="rounded-circle">
                        </div>
                        <div class="chat-help-bubble ml-3">
                            Unfortunately without an active bank account we are unable to continue with your application.
                        </div>
                    </div>
                    <div class="text-center mt-5">
                        <a href="https://arborist.lincx.in/redirect?origin=su03mju&affsub=" id="ca-link" target="_blank">Click here to learn more about opening a checking account</a><br>
                    </div>
                </div><!--End Card Body-->
            </div><!--End Card-->
        </div><!--End Col-->
    </div><!--End Row-->
</template>

<script>
import StepsPercentage from '@/components/form/StepsPercentage.vue';

import { mapGetters, mapActions } from "vuex";

export default {
    name: 'WizardStep4Reject',
    title: 'Apply | Step 4',
    components:{
        StepsPercentage
    },
}
</script>

<style>
    
</style>
